import script from "./SyncDiagram.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncDiagram.vue?vue&type=script&setup=true&lang=ts"

import "./SyncDiagram.vue?vue&type=style&index=0&id=4c86d924&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c86d924"]])

export default __exports__